
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class IssueMaterialDetailsGrid extends Serenity.EntityGrid<IssueMaterialDetailsRow, any> {
        protected getColumnsKey() { return 'Production.IssueMaterialDetails'; }
        protected getDialogType() { return IssueMaterialDetailsDialog; }
        protected getIdProperty() { return IssueMaterialDetailsRow.idProperty; }
        protected getInsertPermission() { return IssueMaterialDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return IssueMaterialDetailsRow.localTextPrefix; }
        protected getService() { return IssueMaterialDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}